import FourtHitRisicoScore from "../../../../src/client/katnh/widgets/4tHitRisicoScore.js";
import * as React from 'react';
export default {
  FourtHitRisicoScore,
  React
};